(function () {
  'use strict';

  angular.module('app').service('ResourceModalService', ResourceModalService);

  ResourceModalService.$inject = ['ModalService'];

  function ResourceModalService(ModalService) {
    const service = {
      openAddResources: openAddResources,
    };

    return service;

    ////////////////////////

    function openAddResources(successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/resources/modals/add-resources-modal.html',
        controller: AddResourcesModalCtrl,
        controllerAs: 'vm',
        inputs: {
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      AddResourcesModalCtrl.$inject = [
        'successCallback',
        'ResourceService',
        'AbilityService',
        'ProviderService',
        'TeamMemberService',
        'VehicleService',
        'UtilService',
        'CONFIGURATIONS',
      ];
    }

    function AddResourcesModalCtrl(
      successCallback,
      ResourceService,
      AbilityService,
      ProviderService,
      TeamMemberService,
      VehicleService,
      UtilService,
      CONFIGURATIONS
    ) {
      const vm = this;

      // public properties
      // -----------------------
      vm.UtilService = new UtilService(vm);
      const config = CONFIGURATIONS;

      vm.permissions = {
        canCreate: AbilityService.can('create_resource_accountadmin'),
        canDestroy: AbilityService.can('destroy_resource_accountadmin'),
      };

      vm.modalTitle = 'ADD_RESOURCES';

      vm.resourceTypes = config.RESOURCE_TYPES;
      vm.resourceContactTypes = config.RESOURCE_CONTACT_TYPES;

      vm.search = {};
      vm.searchContactTypeLabel = false;
      vm.showContacts = false;

      // public methods
      // -----------------------
      vm.selectType = function (type) {
        vm.search.type = type;
        vm.search.contact_type = null;

        vm.searchContactTypeLabel = false;
        vm.showContacts = false;

        if (type === 'vehicle') {
          vm.selectContactType(type);
        }
      };

      vm.selectContactType = function (contact_type) {
        vm.search.contact_type = contact_type;

        vm.showContacts = true;

        getDefaultFilterCriteria();
        getContacts();
      };

      vm.searchContact = function () {
        getContacts();
      };

      vm.selectPage = function () {
        vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;

        getContacts();
      };

      vm.onSort = function (sortedBy, sortDir) {
        vm.filterCriteria.page = 1;
        vm.filterCriteria.sortDir = sortDir;
        vm.filterCriteria.sortedBy = sortedBy;

        getContacts();
      };

      vm.refresh = function () {
        getDefaultFilterCriteria();
        getContacts();
      };

      vm.addResource = function (item) {
        if (!vm.permissions.canCreate) return;

        vm.itemSelected = item;

        let params = {
          type: vm.search.type,
          contact_type: vm.search.contact_type,
          resource_contact_id: item.id,
        };

        vm.addingResource = true;
        ResourceService.saveResource(params).then((data) => {
          if (data) {
            item.is_resource = true;
            item.resource_id = data.id;

            successCallback();
          }

          vm.addingResource = false;
        });
      };

      /*vm.removeResource = function(item){
                if (!vm.permissions.canDestroy) return;

                ResourceService.deleteResource(resource, successCallback());

                // successCallback();

                // $element.modal('hide');
            };*/

      // private methods
      // -----------------------
      function getDefaultFilterCriteria() {
        switch (vm.search.contact_type) {
          case 'provider':
            vm.searchContactTypeLabel = 'SEARCH_PROVIDER';

            vm.filterCriteria = ProviderService.getFilterCriteria();
            break;

          case 'team_member':
            vm.searchContactTypeLabel = 'SEARCH_TEAM_MEMBER';

            vm.filterCriteria = TeamMemberService.getFilterCriteria();
            break;

          case 'vehicle':
            vm.searchContactTypeLabel = 'SEARCH_VEHICLE';

            vm.filterCriteria = VehicleService.getFilterCriteria();
            break;
        }
      }

      function getContacts() {
        switch (vm.search.contact_type) {
          case 'provider':
            getProviders();
            break;

          case 'team_member':
            getTeamMembers();
            break;

          case 'vehicle':
            getVehicles();
            break;
        }
      }

      function getProviders() {
        vm.filterCriteria.is_not_resource = true;

        vm.loadingItems = true;
        ProviderService.getProviders(vm.filterCriteria).then((data) => {
          vm.items = data.items;
          vm.meta = data.meta;

          vm.totalItems = vm.meta.totalItems;

          vm.loadingItems = false;

          vm.showActions = false;
        });
      }

      function getTeamMembers() {
        vm.filterCriteria.is_not_resource = true;

        vm.loadingItems = true;
        TeamMemberService.getTeamMembers(vm.filterCriteria).then((data) => {
          vm.items = data.items;
          vm.meta = data.meta;

          vm.totalItems = vm.meta.totalItems;

          vm.loadingItems = false;

          vm.showActions = false;
        });
      }

      function getVehicles() {
        vm.filterCriteria.is_not_resource = true;

        vm.loadingItems = true;
        VehicleService.getVehicles(vm.filterCriteria).then((data) => {
          vm.items = data.items;
          vm.meta = data.meta;

          vm.totalItems = vm.meta.totalItems;

          vm.loadingItems = false;

          vm.showActions = false;
        });
      }
    }
  }
})();

// vm.searchContactTypeLabel = (type === 'vehicle') ? true : false;
